export default defineNuxtRouteMiddleware(async (to, from) => {
  /**
   * Fetch feature flags after user is authenticated
   */
  const featureFlagsStore = useFeatureFlagsStore();
  await featureFlagsStore.fetchAllFlags();
});
